//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  title: 'socialSecurity',
  data: function data() {
    return {
      tableData: []
    };
  }
};